'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const AttendanceBarChart = dynamic(() => import('./AttendanceBarChart'), { ssr: false });
const PunctualityBarChart = dynamic(() => import('./PunctualityBarChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-2 gap-4">
      <div className="bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <h2 className="text-base font-600 text-foreground" style={{ fontWeight: 600 }}>
            Attendance Rate by Teacher — May 2026
          </h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            Percentage of scheduled days each teacher was present. Red line = 90% threshold.
          </p>
        </div>
        <AttendanceBarChart />
      </div>

      <div className="bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <h2 className="text-base font-600 text-foreground" style={{ fontWeight: 600 }}>
            Punctuality Rate by Teacher — May 2026
          </h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            Percentage of days teacher arrived before contracted time (07:15).
          </p>
        </div>
        <PunctualityBarChart />
      </div>
    </div>
  );
}